import { ReactElement } from "react";
import { NavigationBarMenu } from "../../components/navigation/NavigationBar";
import { NotificationList } from "../../components/notifications/NotificationList";
import { PageContainer } from "../../components/pageContainer/PageContainer";

export const Notification = (): ReactElement => {
  return (
    <>
      {/*<NavigationBar title={"All Notifications"} />{" "}*/}
      <NavigationBarMenu title={"All Notifications"} borderBottom={false} />
      <PageContainer className={"flex flex-col gap-6 bg-zinc-100 pb-4 md:px-6"}>
        <NotificationList
          setPopoverActive={() => {}}
          isNotificationPopover={false}
        />
      </PageContainer>
    </>
  );
};
